import { Directive, Input, TemplateRef, ViewContainerRef, effect } from '@angular/core';
import { StaffModuleSlug } from './permission.constants';
import { PermissionService } from './permission.service';

@Directive({
  selector: '[appHasModule]',
  standalone: true,
})
export class HasModuleDirective {
  private moduleSlug: StaffModuleSlug | null = null;
  private viewCreated = false;

  @Input({ required: true })
  set appHasModule(slugCode: StaffModuleSlug) {
    this.moduleSlug = slugCode;
    this.updateView();
  }

  constructor(
    private readonly templateRef: TemplateRef<unknown>,
    private readonly viewContainer: ViewContainerRef,
    private readonly permissionService: PermissionService,
  ) {
    effect(() => {
      this.isEnabled();
      this.updateView();
    });
  }

  private isEnabled(): boolean {
    return (
      this.moduleSlug !== null && this.permissionService.hasModule(this.moduleSlug)
    );
  }

  private updateView(): void {
    const enabled = this.isEnabled();

    if (enabled && !this.viewCreated) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.viewCreated = true;
      return;
    }

    if (!enabled && this.viewCreated) {
      this.viewContainer.clear();
      this.viewCreated = false;
    }
  }
}
